import { RandomGenerator } from "../test-utils";
var AccountDetailsBuilder = /** @class */ (function () {
    function AccountDetailsBuilder() {
        this.accountDetails = {
            domains: {
                total: RandomGenerator.randomNumber(1, 100),
                connected: RandomGenerator.randomNumber(1, 100),
            },
            plans: RandomGenerator.randomNumber(1, 100),
            gsuite: {
                accounts: RandomGenerator.randomNumber(1, 100),
                seats: RandomGenerator.randomNumber(1, 100),
            },
        };
    }
    AccountDetailsBuilder.prototype.withDomains = function (domains) {
        this.accountDetails.domains = domains;
        return this;
    };
    AccountDetailsBuilder.prototype.withSites = function (sites) {
        this.accountDetails.sites = sites;
        return this;
    };
    AccountDetailsBuilder.prototype.withPlans = function (plans) {
        this.accountDetails.plans = plans;
        return this;
    };
    AccountDetailsBuilder.prototype.withGsuite = function (gsuite) {
        this.accountDetails.gsuite = gsuite;
        return this;
    };
    AccountDetailsBuilder.prototype.build = function () {
        return this.accountDetails;
    };
    return AccountDetailsBuilder;
}());
export { AccountDetailsBuilder };
//# sourceMappingURL=account-details.builder.js.map